// dependencies
import React from "react";

import { Spinner } from "@performyard/py-components";

// components
import Text from "../../../../../../components/Text";
import { CardBody, CardHeader } from "../../../../components/Card";

// store
import useStore from "../../../../store";

// hooks
import { useParticipationRateSummary } from "../../../../../../api/hooks";

import Config from "../../../../Config";
import QuestionsKPIBarChart from "../QuestionsKPIBarChart";
//css
import css from "../shared.module.scss";

const ParticipationSummary = () => {
	// setup
	const [filter] = useStore((state) => [state.filter]);
	const binSize = Config.BIN_SIZE;

	const { data, isLoading } = useParticipationRateSummary({
		startDate: filter.startDate,
		endDate: filter.endDate,
		binSize,
	});

	const participationData = data?.data || null;
	const percentage = participationData?.participation_rate ? Math.round(participationData.participation_rate) : 0;
	const monthlyData =
		participationData?.monthlyAverages?.map((data) => ({
			time_bucket: data.time_bucket,
			average: data.response_count / data.total_surveys,
		})) || [];

	return (
		<>
			<CardHeader
				title={
					<span>
						<Text element="span" size="paragraph-2" weight="regular">
							Participation{" "}
							<Text element="span" size="paragraph-2" weight="semi-bold">
								Rate
							</Text>
						</Text>
					</span>
				}
				info="This chart displays the participation rate of all surveys during the selected period."
			/>
			<CardBody>
				{isLoading && (
					<div className={css.spinner}>
						<Spinner size={20} />
					</div>
				)}
				{!isLoading && (
					<div className={css.cardBody}>
						<div className={css.leftContent}>
							<p className={css.largeText}>{percentage}%</p>
							<Text size="caption" weight="semi-bold" className={css.subText}>
								Employee Responses
							</Text>
						</div>
						<div className={css.barChart}>
							<QuestionsKPIBarChart monthlyData={monthlyData} />
						</div>
					</div>
				)}
			</CardBody>
		</>
	);
};

export default ParticipationSummary;
